'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var IMAGE_TYPE = exports.IMAGE_TYPE = 'IMAGE';
var IMAGE_DISPLAY_NAME = exports.IMAGE_DISPLAY_NAME = 'Image';

// Image size constants
var IMAGE_WIDTH_THUMB = exports.IMAGE_WIDTH_THUMB = 1;
var IMAGE_WIDTH_REGULAR = exports.IMAGE_WIDTH_REGULAR = 400;
var IMAGE_WIDTH_LARGE = exports.IMAGE_WIDTH_LARGE = 800;
var IMAGE_WIDTH_MAX = exports.IMAGE_WIDTH_MAX = 1600;

var IMAGE_MIN_WIDTH_GRID = exports.IMAGE_MIN_WIDTH_GRID = 8;

var IMAGE_SIZES = exports.IMAGE_SIZES = {
    THUMB: {
        name: 'thumb',
        width: IMAGE_WIDTH_THUMB
    },
    REGULAR: {
        name: 'regular',
        width: IMAGE_WIDTH_REGULAR,
        quality: 75
    },
    LARGE: {
        name: 'large',
        width: IMAGE_WIDTH_LARGE,
        quality: 70
    },
    HUGE: {
        name: 'huge',
        width: IMAGE_WIDTH_MAX,
        quality: 65
    },
    ORIGINAL: {
        name: 'original',
        width: Infinity,
        original: true
    }
};

// Document mode
var DOC_MODE_IMAGE_WIDTH = exports.DOC_MODE_IMAGE_WIDTH = 716;

var LINKED_IMAGE_URL_PREFIX = exports.LINKED_IMAGE_URL_PREFIX = '/api/media/safe?url=';


//////////////////
// WEBPACK FOOTER
// ./src/common/images/imageConstants.js
// module id = 87
// module chunks = 0